import React, { Component } from "react";
import { AuthTopNav } from "../containers/TopNav";
import LoadingIndicator from "../components/LoadingIndicator";
import { connect } from "react-redux";
import { loggedInUserGuid } from "../store/iam/selectors";
import { navigate } from "../store/navigation/operations";
import { createSimpleConversation } from "../store/messaging/operations";
import { getUserWithId } from "../store/users/selectors";
import { fetchUser } from "../store/users/operations";
import {isLoggedIn } from "../store/iam/selectors";

export class NewConversation extends Component {

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isLoggedIn !== prevProps.isLoggedIn) {
      this.init();
    }
    if (this.props.sender && this.props.receiver && this.props.isLoggedIn) {
      this.props.createSimpleConversation(this.props.sender, this.props.receiver);
    }
  }
   
  componentDidMount() {
    this.init();
  }

  init=()=>{
    if(this.props.isLoggedIn){
      this.props.fetchUser(this.props.match.params.receiverGuid);
      if (this.props.myGuid) {
        this.props.fetchUser(this.props.myGuid);
      }
      if (this.props.sender && this.props.receiver) {
        this.props.createSimpleConversation(this.props.sender, this.props.receiver);
      }
    }
  }

  render() {
    return (
      <div>
        <AuthTopNav />
        {this.props.isLoggedIn && <LoadingIndicator />}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    isLoggedIn: isLoggedIn(state),
    receiver: getUserWithId(state, props.match.params.receiverGuid),
    sender: getUserWithId(state, loggedInUserGuid(state))
  };
};

const mapDispatchToProps = dispatch => ({
  navigate: to => dispatch(navigate(to)),
  fetchUser: user_guid => dispatch(fetchUser(user_guid)),
  createSimpleConversation: (sender, receiver) => dispatch(createSimpleConversation(sender, receiver))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewConversation);
